import AbstractController from '../src/services/ControllersRepository/AbstractController';
import ContractorCreateForm from '@views/contractors/ContractorCreateForm';
import ContractorUpdateForm from '@views/contractors/ContractorUpdateForm';

export default class Contractors extends AbstractController {
    protected controllerName = 'Contractors';

    protected getDefaultCreateFormComponent() {
        return ContractorCreateForm;
    }

    protected getDefaultUpdateFormComponent() {
        return ContractorUpdateForm;
    }
}
